module.exports = __webpack_public_path__ + "assets/eee22701726b119f38cfecbb2543d3a4.mp3";